import { useEffect, useRef, useState } from "react";

import { useHistory } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";


import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";


import { Image } from "react-bootstrap";

import MaleIcon from "../../assets/MaleIcon.svg";
import FemaleIcon from "../../assets/FemaleIcon.svg";

import {
	IconButton,
	FormControl,
	TextField,
	FormGroup,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	DialogActions,
	Alert,
	CircularProgress,
	Backdrop,
} from "@mui/material";
import { userLogin } from "../../services/wapi";
import WalletOTP from "../otp/wallet";
import { labsDetails } from "../../constants/constant";

export const UserLoginDialog = ({ userName, getControl, errorAlert }) => {
	const [isLoading, setLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);

	const [email, setEmail] = useState("");
	const emailRef = useRef(email);

	const [phone, setPhone] = useState(null);
	const phoneRef = useRef(phone);
	const [phoneErr, setPhoneErr] = useState(false);

	const [showLogin, setShowLogin] = useState(false);

	const [patientName, setPatientName] = useState("");
	const nameRef = useRef(null);

	const [dob, setDob] = useState(null);

	const [gender, setGender] = useState("F");

	const [walletVerification, setWalletVerification] = useState(false);

	const history = useHistory();

	const handleClose = (error) => {
		setShowLogin(false);
		getControl(false);

		error && errorAlert(error);
	};

	const submitForm = async () => {
		const re = /^[0-9\b]+$/;
		if (phone.length != 10 || !re.test(phone)) {
			phoneRef.current.focus();
			setPhoneErr(true);
			return;
		}

		setWalletVerification(true);
	};

	const userCheck = async () => {
		labsDetails.userLoginDetails = {};

		if (!userName) {
			setShowLogin(true);
			return;
		}

		await proceedWithLogin();
	};

	const otpVerificationSuccessHandler = async () => {
		labsDetails.userLoginDetails = {
			phone,
			email,
			dob: dob?.add(10, "hours")?.toISOString(),
			gender,
			name: patientName,
		};

		await proceedWithLogin();
	};

	const proceedWithLogin = async () => {
		setLoading(true);
		setPhoneErr(false);
		setShowAlert(false);

		try {
			const response = await userLogin({
				userName,
				phoneNumber: phone,
				...labsDetails.userLoginDetails,
			});

			if (!response.shortToken) throw new Error();

			localStorage.setItem("user_short_token", response.shortToken);

			// getControl(false);

			history.push("/labs/userBenefits");
		} catch (ex) {
			setShowAlert(true);

			!showLogin && handleClose("Unable to login user");
		} finally {
			setLoading(false);
		}
	};

	useEffect(async () => {
		await userCheck();
	}, []);

	return (
		<>
			<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
				<CircularProgress />
			</Backdrop>
			<Dialog
				open={showLogin}
				onClose={() => handleClose(false)}
				className="bottom-sheet-modal"
			>
				<DialogTitle>Login</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={() => handleClose(false)}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent style={{ paddingTop: "15px" }}>
					<div className="d-flex justify-content-between align-items-center m-b-30">
						<div className="text-center">
							<Image src={gender == "F" ? FemaleIcon : MaleIcon} height="75" />
						</div>
						<div className="d-flex gender-selector">
							<div
								className={`py-2 px-3 border ${gender === "F" ? "active" : ""}`}
								style={{
									borderTopLeftRadius: "20px",
									borderBottomLeftRadius: "20px",
								}}
								onClick={() => setGender("F")}
							>
								Female
							</div>
							<div
								className={`py-2 px-3 border ${gender === "M" ? "active" : ""}`}
								style={{
									borderTopRightRadius: "20px",
									borderBottomRightRadius: "20px",
								}}
								onClick={() => setGender("M")}
							>
								Male
							</div>
						</div>
					</div>

					<FormControl fullWidth>
						<FormGroup>
							<TextField
								label="Email"
								type="email"
								style={{ marginBottom: "20px" }}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								inputRef={emailRef}
								required
							/>

							<TextField
								label="Phone Number"
								type="tel"
								style={{ marginBottom: "20px" }}
								value={phone || ""}
								onChange={(e) => setPhone(e.target.value)}
								inputRef={phoneRef}
								required
								error={phoneErr}
							/>

							<TextField
								label="Patient name"
								style={{ marginBottom: "20px" }}
								value={patientName}
								onChange={(e) => setPatientName(e.target.value)}
								inputRef={nameRef}
								required
							/>

							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DatePicker
									label="Date of birth"
									value={dob}
									maxDate={moment()}
									onChange={(val) => setDob(val)}
									format="MMM DD, YYYY"
									required
								/>
							</LocalizationProvider>
						</FormGroup>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button
						fullWidth
						variant="contained"
						color="primary"
						disabled={!phone || !email || !patientName || !dob}
						onClick={submitForm}
					>
						Submit
					</Button>
				</DialogActions>

				{!isLoading && showAlert && (
					<Alert severity="error" sx={{ marginTop: "20px" }}>
						Unable to login user
					</Alert>
				)}
			</Dialog>

			{walletVerification && (
				<WalletOTP
					visible={walletVerification}
					setVisibility={setWalletVerification}
					onSuccess={otpVerificationSuccessHandler}
					phone={phone}
					type={"Order_Create_OTP"}
				/>
			)}
		</>
	);
};
